import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import FilterButton from 'components/search_sidebar/filter_button';
import CompsFilterRow from './comps_filter_row';
import FilterTopbar from 'components/search_page/filter_topbar';

import CompsSaleOrLeaseFilterGroup from './comps_sale_or_lease_filter_group';
import CompsCurrentFiltersGroup from './comps_current_filters_group';
import CompsFiltersContainer from './comps_filters_container';
import CustomFieldFilters from '../custom_fields/filters';

import { clearFilters, clearFiltersIfEmpty, changeSearchText } from '../store/actions/query';
import { switchTab } from '../store/actions/ui';
import { delayRetrieveRecords, retrieveLeases, retrieveSales } from '../store/actions/search';

import { initialState } from 'helpers/comps/database_table_constants';
export class CompsFilterTopbar extends React.Component {
  static propTypes = {
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    currentTab: PropTypes.string.isRequired,
    delayRetrieveRecords: PropTypes.func,
    edgeCrm: PropTypes.bool,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    }),
    retrieveLeases: PropTypes.func.isRequired,
    retrieveSales: PropTypes.func.isRequired,
    searchText: PropTypes.string.isRequired,

    onChangeSearchText: PropTypes.func.isRequired,
    onChangeTab: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { delayRetrieveRecords } = this.props;
    delayRetrieveRecords();
  }

  handleClearFilters = () => {
    const {
      delayRetrieveRecords,
      onClearFilters
    } = this.props;

    onClearFilters(initialState);
    delayRetrieveRecords();
  };

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  }

  handleSearchChange = (e) => {
    const { onChangeSearchText } = this.props;
    onChangeSearchText(e.target.value);
    this.handleRetrieveRecords();
  };

  handleChangeTab = (tab) => {
    const { onChangeTab, retrieveLeases, retrieveSales } = this.props;
    onChangeTab(tab);
    tab == "lease" ? retrieveLeases() : retrieveSales();
  }

  render() {
    return (
      <FilterTopbar>
        <div>{this.renderFilters()}</div>
        <div className="hidden-xs hidden-sm">
          <div className="left-buffer-md container-fluid">
            <CompsCurrentFiltersGroup />
          </div>
        </div>
      </FilterTopbar>
    );
  }

  renderCompsSelector() {
    const { currentTab } = this.props;
    const lease = currentTab == "lease";


    return (
      <FilterButton
        filtersApplied={false}
        label={lease ? "Lease Comps" : "Sale Comps"}
        name="sale-or-lease"
      >
        <div className="clickable bottom-buffer-xs" onClick={() => this.handleChangeTab("lease")}>
          <div style={{ "fontWeight": lease ? "bold" : "normal" }}>Lease Comps</div>
        </div>
        <div className="clickable bottom-buffer-xs" onClick={() => this.handleChangeTab("sale")}>
          <div style={{ "fontWeight": !lease ? "bold" : "normal" }}>Sale Comps</div>
        </div>
      </FilterButton>
    );
  }

  renderFilters() {
    const { pageData, searchText, } = this.props;


    return (
      <CompsFilterRow
        edgeCrm={this.props.edgeCrm}
        pageData={pageData}
        searchPlaceholder="Search by name, address, city, state, zip"
        searchText={searchText}
        onSearchChange={this.handleSearchChange}
      >
        {this.renderCompsSelector()}
        <CompsSaleOrLeaseFilterGroup />
        <CompsFiltersContainer />
        <CustomFieldFilters/>
      </CompsFilterRow>
    );
  }
}

const mapStateToProps = state => ({
  ...state.static,
  currentTab: state.ui.currentTab,
  edgeCrm: state.features.edgeCrm,
  searchText: state.query.searchText,
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  retrieveLeases,
  retrieveSales,

  onClearFilters: clearFilters,
  onChangeSearchText: changeSearchText,
  onChangeTab: switchTab
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsFilterTopbar);
